module.exports = __webpack_public_path__ + "static/media/rlgalogo_xlarge.45b97141.png";